import * as types from "./actionTypes";

const initialState = {
  userDetail: {},
  updated: false,
};

export default function reduce(state = initialState, action = {}) {
  switch (action.type) {
    case types.RESET_ACTION:
      return initialState;

    case types.RESET:
      return {
        ...state,
        userDetail: {},
        updated: false,
      };

    case types.COMPANY_UPDATE_ACTION:
      //console.log("Reducer received update:", action.payload);
      const linkedinUrl = action.payload.linkedin_url || action.payload.linkedinURL || state.userDetail.linkedin_url || state.userDetail.linkedinURL || "";
      return {
        ...state,
        userDetail: {
          ...action.payload,
          linkedin_url: linkedinUrl,
          linkedinURL: linkedinUrl,
        },
        updated: true,
      };

    default:
      return state;
  }
}
